import { FC, useState } from "react";
import { Input, Modal, message } from "antd";

import { requestAnalysisChange } from "../../../common/api/ProjectClient";
import { handleError } from "../../../common/ErrorHandling";
import { ProjectViewState } from "../ProjectViewState";

interface ModalRequestChangeProps {
    open: boolean;
    state: ProjectViewState;
    onClose: () => void;
    onSuccess: () => void;
}

export const ModalRequestChange: FC<ModalRequestChangeProps> = ({
    open,
    state,
    onClose,
    onSuccess,
}) => {
    const { project } = state;
    const [requestMessage, setRequestMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!requestMessage.trim()) return;
        try {
            setIsSubmitting(true);
            await requestAnalysisChange(project.id, requestMessage.trim());
            message.success("Change requested");
            setRequestMessage("");
            onClose();
            onSuccess();
        } catch (error) {
            handleError(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        setRequestMessage("");
        onClose();
    };

    return (
        <Modal
            title="Request change"
            open={open}
            onOk={handleSubmit}
            onCancel={handleCancel}
            okText="Send request"
            okButtonProps={{ disabled: !requestMessage.trim(), loading: isSubmitting }}
            cancelButtonProps={{ disabled: isSubmitting }}
        >
            <p>Describe what changes are needed:</p>
            <Input.TextArea
                rows={4}
                value={requestMessage}
                onChange={(e) => setRequestMessage(e.target.value)}
                placeholder="Please provide details about the required changes..."
                disabled={isSubmitting}
            />
        </Modal>
    );
};
